import { render, staticRenderFns } from "./CustomerInsuranceDetail.vue?vue&type=template&id=18d0225e&scoped=true&"
import script from "./CustomerInsuranceDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerInsuranceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0225e",
  null
  
)

export default component.exports